<template>
  <div class="message-box dialog-mask" @click="focusOut">
    <div class="dialog-content">
      <header>{{ title }}</header>
      <div class="dialog-body">
        <div v-html="content"></div>
      </div>
      <footer>
        <div class="button-area">
          <button class="button" @click="$close(true)">{{ okButton || $t('common.yes') }}</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  props: {
    title: String,
    content: String,
    okButton: {
      type: String,
      default: undefined,
    },
    cancelButton: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    cancel() {
      this.$close(false);
    },
    focusOut(e) {
      // if (e.target.classList.contains("dialog-mask")) {
      //   //  this.$close(false);
      // }
    },
  },
});
</script>

<style lang="scss" scoped>
header {
  font-weight: bold;
  font-size: large;
  margin: 15px auto;
}

.button-area {
  margin: 10px auto;
  float: right;
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dialog-body {
  font-size: larger;
}

.dialog-mask {
  position: fixed;
  top: -100px;
  right: 0;
  bottom: 0;
  left: 0;
  display: -ms-flexbox;
  display: flex;
  z-index: 9000;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.33);
}

.dialog-content {
  margin: 0 10px;
  padding: 10px 15px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background-color: var(--color-bg);
  box-shadow: 0 2px 12px 0 var(--color-shadow);
  color: var(--color-text);
}
</style>
